import { render, staticRenderFns } from "./EmployeeIndex.vue?vue&type=template&id=12f6b7a6"
import script from "./EmployeeIndex.vue?vue&type=script&lang=js"
export * from "./EmployeeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports